export type NewTaskRecurrenceType = 'NONE' | 'DAILY' | 'WEEKLY' | 'MONTHLY';

/** Days of the month offered by the monthly picker. 29-31 fall on the last day in shorter months (backend). */
export const MONTH_DAYS: readonly number[] = Array.from({ length: 31 }, (_, index) => index + 1);

/** The day of the month for the user's current day (YYYY-MM-DD), falling back to the browser's date. */
export function todayDayOfMonth(dayDate: string | null | undefined): number {
  const parsed = dayDate ? Number.parseInt(dayDate.slice(8, 10), 10) : Number.NaN;
  return Number.isInteger(parsed) && parsed >= 1 && parsed <= 31 ? parsed : new Date().getDate();
}

/** Days to preselect when the Repeat type changes: today's date for Monthly, nothing otherwise. */
export function initialRecurrenceDays(type: NewTaskRecurrenceType, dayDate: string | null | undefined): number[] {
  return type === 'MONTHLY' ? [todayDayOfMonth(dayDate)] : [];
}

/** Validation message when the chosen type needs days and none are selected, else null. */
export function recurrenceDaysError(type: NewTaskRecurrenceType, days: readonly number[]): string | null {
  if (days.length > 0) {
    return null;
  }
  if (type === 'WEEKLY') {
    return 'Select at least one weekday for weekly recurrence.';
  }
  if (type === 'MONTHLY') {
    return 'Select at least one day of the month for monthly recurrence.';
  }
  return null;
}

/** The recurrenceDays value for the API (comma-separated, sorted), or undefined when the type takes none. */
export function formatRecurrenceDays(type: NewTaskRecurrenceType, days: readonly number[]): string | undefined {
  if (type !== 'WEEKLY' && type !== 'MONTHLY') {
    return undefined;
  }
  return [...days].sort((left, right) => left - right).join(',');
}
